var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bi:list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    transform: "translate(-12.000000, -40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bi:list",
    transform: "translate(12.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 4.500000)",
    fill: "#E63C28",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75,13.5 C0.75,13.0857864 1.08578644,12.75 1.5,12.75 L16.5,12.75 C16.9142136,12.75 17.25,13.0857864 17.25,13.5 C17.25,13.9142136 16.9142136,14.25 16.5,14.25 L1.5,14.25 C1.08578644,14.25 0.75,13.9142136 0.75,13.5 Z M0.75,7.5 C0.75,7.08578644 1.08578644,6.75 1.5,6.75 L16.5,6.75 C16.9142136,6.75 17.25,7.08578644 17.25,7.5 C17.25,7.91421356 16.9142136,8.25 16.5,8.25 L1.5,8.25 C1.08578644,8.25 0.75,7.91421356 0.75,7.5 Z M0.75,1.5 C0.75,1.08578644 1.08578644,0.75 1.5,0.75 L16.5,0.75 C16.9142136,0.75 17.25,1.08578644 17.25,1.5 C17.25,1.91421356 16.9142136,2.25 16.5,2.25 L1.5,2.25 C1.08578644,2.25 0.75,1.91421356 0.75,1.5 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.a11619db45b131e101165fcbd7cf417e.svg";
export { ForwardRef as ReactComponent };